import { createTypedUseAuth } from '@codezo/auth';
import { AuthRoleEnum, CurrencyEnum } from '@codezo/graphql';

export type OrganizationUserType = {
	id: string;
	email: string;
	role: AuthRoleEnum;
	organizationId: string;
	organization: {
		id: string;
		name: string;
		onboarded: boolean;
		organizationSetting?: {
			currency: CurrencyEnum;
		} | null;
	};
	organizationUser: {
		id: string;
		firstName: string;
		lastName: string;
	};
};

export const useAuth = createTypedUseAuth<OrganizationUserType>();
